import * as React from "react";
import { Context } from "./context";

export const Provider = ({ children }: { children: React.ReactNode }) => {
  const [path, setPath] = React.useState<string[]>([]);
  return (
    <Context.Provider value={{ path, setPath }}>{children}</Context.Provider>
  );
};
